module.exports = __webpack_public_path__ + "media/4x3/bt-65b20c56.svg";